module.exports = __webpack_public_path__ + "img/app-shape-3.ac66c750.png";